var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0026 36.6673H25.0026C33.3359 36.6673 36.6693 33.334 36.6693 25.0007V15.0007C36.6693 6.66732 33.3359 3.33398 25.0026 3.33398H15.0026C6.66927 3.33398 3.33594 6.66732 3.33594 15.0007V25.0007C3.33594 33.334 6.66927 36.6673 15.0026 36.6673Z",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9974 16.6667C16.8383 16.6667 18.3307 15.1743 18.3307 13.3333C18.3307 11.4924 16.8383 10 14.9974 10C13.1564 10 11.6641 11.4924 11.6641 13.3333C11.6641 15.1743 13.1564 16.6667 14.9974 16.6667Z",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45312 31.5836L12.6698 26.0669C13.9865 25.1836 15.8865 25.2836 17.0698 26.3003L17.6198 26.7836C18.9198 27.9003 21.0198 27.9003 22.3198 26.7836L29.2531 20.8336C30.5531 19.7169 32.6531 19.7169 33.9531 20.8336L36.6698 23.1669",
    stroke: "#1C1C1C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoCenter);
export default __webpack_public_path__ + "static/media/PhotoCenter.208c8ef64e153eeeafe929dd94b2cb9b.svg";
export { ForwardRef as ReactComponent };